// v240603.1

$(function() {
	$('form').not('.novalidate').attr('novalidate', 'novalidate').each(function() {
		var $form = $(this);
		var $submit = $form.find('[type=submit]');
		var loadingMax = $(this).data('loading-max') || 5;
		var started = false;

		var getInputs = function() {
			return $form.find('select, input, textarea');
		};

		var formatDate = function(year, month, day) {
			if (("" + month).length === 1) month = '0' + month;
			if (("" + day).length === 1)   day   = '0' + day;
			var result = year + '-' + month + '-' + day;
			if (result === '--') result = '';
			return result;
		};

		var getAge = function(year, month, day) {
			if (isNaN(Date.parse(formatDate(year, month, day)))) {
				return false;
			}

			year    = parseInt(year);
			month   = parseInt(month);
			day     = parseInt(day);

			var today   = new Date();
			var age     = today.getFullYear() - year;

			if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) {
				age--;
			}

			if (age > 130 || age < 0) {
				return false;
			}

			return age;
		};

		var getError = function($field) {
			var $group = $field.closest('.form-group');
			var $error = $group.find('.input-error');

			if ($error.length === 0) {
				return $('<div>');
			}

			return $error;
		}

		var toggleError = function($field) {
			var $error        = getError($field);
			var $group        = $error.closest('.form-group');
			var errorType     = $error.data('error-type') || '';
			var errorSettings = $error.data('error-default') || {};
			var errorMessage  = errorSettings[errorType] || errorSettings['default'] || '';

			$error.html(errorMessage);

			if (errorType) {
				$field.data('had-error', true);
				showErrorElement($error);

			} else {
				$group.removeClass('form-error');
				$error.addClass('d-none').html('');
			}
		};

		var showErrorElement = function($error) {
			var $group = $error.closest('.form-group');

			if ($error.text().trim() !== '') {
				$error.removeClass('d-none');
			}

			$group.addClass('form-error');
		};

		var hideError = function($field) {
			getError($field).data('error-type', '');
			toggleError($field);
		};

		var gotoFirstError = function() {
			var $firstError = $form.find('.form-error');

			if ($firstError.length === 0) {
				return;
			}

			// If the form is in a modal, open the modal
			if ($form.closest('.modal').length > 0) {
				$form.closest('.modal').modal();

			} else {
				setTimeout(() => {
					smoothScrollToCenter($firstError, $firstError.outerHeight() / 2);
				}, 500);
			}
		};

		var checkServersideErrors = function() {
			var $allErrors = $form.find('.input-errors-all');

			$form.find('.input-error').each(function() {
				var field  = $(this).attr('data-error-name');
				var $error = $allErrors.find('[data-error-name="' + field + '"]');

				if ($error.length > 0) {
					$error.remove(); // Hide error in form top error listing
					showErrorElement($(this));
				}
			});

			if ($allErrors.text().trim() === '') {
				$allErrors.hide();
			} else {
				$allErrors.slideDown('fast');
			}

			gotoFirstError();
		}

		var validateField = function($field, e) {
			if ($field.data('validation') === 'none') return true;
			if (e.type === 'input' && !$field.data('had-error')) return true;

			var $group      = $field.closest('.form-group');
			var $error      = $group.find('.input-error');
			var name        = $field.attr('name');
			var value       = $field.val();
			var validateStr = $field.data('validate') || '';
			var validate    = validateStr ? validateStr.split(',') : [];
			var type        = $field.get(0).type;
			var errorType   = '';

			if (!$group.is(':visible')) {
				hideError($error);
				return true;
			}

			if ($group.hasClass('form-required')) {
				validate.unshift('required');
			}

			validate.push(type);

			$.each(validate, (key, validateItem) => {
				var checkParts = validateItem.split(':');
				var check      = checkParts[0];
				var args       = checkParts[1];

				switch (check) {
					case 'required':
						switch (type) {
							default:
								if (value === '') {
									errorType = 'required';
									return false;
								}
								break;

							case 'checkbox':
							case 'radio':
								if (getInputs().filter('[name="' + name + '"]:checked').length === 0) {
									errorType = 'required';
									return false;
								}
						}
						break;

					case 'email':
						if (value === '') break;
						if (!/^.+@.+\..{2,}$/.test(value)) {
							errorType = 'email';
							return false;
						}
						break;

					case 'date':
						if (value === '') break;
						var dateParts    = value.split('-');
						var date         = new Date($field.val());
						var dateParsed   = formatDate(date.getFullYear(), date.getMonth() + 1, date.getDate());

						if (isNaN(date.getTime()) || dateParsed !== formatDate(dateParts[0], dateParts[1], dateParts[2]) || dateParts[0].length < 4) {
							errorType = 'date';
							return false;
						}
						break;

					case 'dob':
					case 'age':
						if (value === '') break;
						var dateParts  = value.split('-');
						var age        = getAge(dateParts[0], dateParts[1], dateParts[2]);

						if (age === false) {
							errorType = 'dob';
							return false;
						}

						if (check === 'age' && age < args) {
							errorType = 'age';
							return false;
						}
						break;
				}
			});

			$error.data('error-type', errorType);

			if (errorType) {
				$field.data('had-error', true);
				toggleError($field);

			} else {
				hideError($field);
			}

			return errorType === '';
		};

		$form.on('focus', 'select, input, textarea', function() {
			if (!started) {
				$form.trigger('start');
			}

			started = true;
		});

		$form.on('blur change input', 'select, input, textarea', function(e) {
			validateField($(this), e);
		});

		$form.not('.debug').on('submit fake-submit', function(e) {
			var hasErrors = false;
			var errorFields = [];

			getInputs().each(function() {
				if (!validateField($(this), e)) {
					errorFields.push($(this));
					hasErrors = true;
				}
			});

			$submit.prop('disabled', true);

			if (hasErrors) {
				e.preventDefault();
				e.stopImmediatePropagation();

				$submit.removeClass('loading');

				setTimeout(function() {
					$submit.prop('disabled', false);
				}, 2000);

				gotoFirstError();
				$form.trigger('submit-fail', {fields: errorFields});

			} else {
				setTimeout(function() {
					$submit.prop('disabled', false);
				}, loadingMax * 1000);

				$form.trigger('submit-success');
			}
		});

		checkServersideErrors();

		// $form.on('submit-fail', function(e, data) {
		// 	console.log('submit fail', data);
		// }).on('submit-success', function() {
		// 	console.log('submit success');
		// });
	});
});
